import React, { useState, useEffect } from "react"
import { Row, Col, Input, Switch, Select, Space } from "antd"
import BulletPointTicket from "./components/BulletPointNew"
import offerBox from "images/landing-page/offer-box.png"
import statistics from "images/v2/statistics.png"
import Aos from "aos"
import "aos/dist/aos.css"
import { useMediaQuery } from "react-responsive"

const bulletPoints = [
  "Visos siuntimo kainos vienoje vietoje",
  "Specialūs pasiūlymai verslui",
  "Kuo daugiau siuntų- tuo mažesnės kainos",
  "Patogus atsiskaitymas užsakant gabenimo paslaugą",
]

const SystemSection = () => {
  const isMobileScreen = useMediaQuery({ query: "(max-width: 992px)" })

  return (
    <>
      <Row
        gutter={{ lg: 16 }}
        align="middle"
        className="front-page-section"
        style={{
          paddingBottom: "50px",
          paddingTop: "20px",
        }}

      >
       

        <Col span={24} order={1} lg={{ span: 10, offset: 4, order: 0 }}>
          <div
            data-aos={isMobileScreen ? "" : "flip-right"}
            style={{
              display: "flex",
              justifyContent: isMobileScreen ? "center" : "start",
            }}
          >
            <div style={{ maxWidth: 600 }}>
              <div className="section-title">{"Geros kainos!"}</div>

              <div
                className="section-sub-title"
                style={{ marginTop: "18px", marginBottom: "5px" }}
              >
                {
                  "Siunčiantiems siuntas nuolat- nuolaidos ir specialūs pasiūlymai"
                }
              </div>

              {bulletPoints.map((point, index) => (
                <div className="section-bullet-point" key={index}>
                  <Space size="small" style={{ alignItems: "center" }}>
                    <BulletPointTicket />
                    <div>{point}</div>
                  </Space>
                </div>
              ))}
            </div>
          </div>
        </Col>
         <Col span={24} order={0} lg={{ span: 7, offset: 1, order: 1 }}>
          <div
            style={{
              display: "flex",
              justifyContent: isMobileScreen ? "center" : "start",
            }}
          >
            <div data-aos={isMobileScreen ? "" : "fade-left"}>
              <img
                src={statistics}
                style={{
                  width: "100%",
                  maxWidth: "300px",
                  marginTop: isMobileScreen && 30,
                  marginRight: !isMobileScreen && 60,
                }}
              />
            </div>
          </div>
        </Col>
      </Row>
    </>
  )
}

export default SystemSection
